module.exports = __webpack_public_path__ + "img/HOL.1a295373.svg";